/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './tournament-hills.stache';
import can from 'can';
import _ from 'lodash';
import appContext from 'scripts/app-context';
import DomEventsManager from 'scripts/dom-events-manager';
import FeedService from 'scripts/services/base-feed-service';
import dtm from 'scripts/services/dtm';

const filters = {
    all: 'All',
    local: 'Local',
    final: 'Final',
    exemptions: 'Exemptions',
};

const erinHillsFeedUrl = window.globalSettings.feeds.erinHills;

Component.extend({
    tag: 'tournament-hills',
    template: template,
    viewModel: {
        isLoaded: false,
        searchString: null,
        basicSearch: null,
        groupedEmptyResult: false,
        emptyResult: false,
        playerBasicViewLimit: 20,
        players: null,
        activePlayerId: null,
        define: {
            activeFilter: {
                Type: can.Map,
                Value: can.Map,
            },
            players: {
                Type: can.List,
                Value: can.List,
            },
            groups: {
                Type: can.List,
                Value: can.List,
            },
            filters: {
                Type: can.Map,
                Value: can.Map,
            },
            groupedPlayers: {
                get() {
                    can.batch.start();
                    let groups = this.attr('groups');
                    let searchString = this.attr('searchString');
                    let filter = this.attr('activeFilter').attr('type');
                    let playerBasicViewLimit = this.attr(
                        'playerBasicViewLimit',
                    );
                    let totalVisiblePlayers = 0;

                    groups.each((group) => {
                        let players = group.attr('players');
                        players.each((player, index) => {
                            if (filter == 'local') {
                                if (player.attr('hasLocalQualifier')) {
                                    player.attr('visible', true);
                                } else {
                                    player.attr('visible', false);
                                }
                            } else if (filter == 'final') {
                                if (player.attr('hasFinalQualifier')) {
                                    player.attr('visible', true);
                                } else {
                                    player.attr('visible', false);
                                }
                            } else if (filter == 'exemptions') {
                                if (player.attr('hasExemptions')) {
                                    player.attr('visible', true);
                                } else {
                                    player.attr('visible', false);
                                }
                            } else {
                                player.attr('visible', true);
                            }

                            let playerItem = group.attr('players').attr(index);
                            if (searchString) {
                                searchString = searchString.toLocaleLowerCase();
                                if (
                                    !_.startsWith(
                                        player
                                            .attr('firstName')
                                            .toLocaleLowerCase(),
                                        searchString,
                                    ) &&
                                    !_.startsWith(
                                        player
                                            .attr('lastName')
                                            .toLocaleLowerCase(),
                                        searchString,
                                    )
                                ) {
                                    playerItem.attr('visible', false);
                                }
                            }
                        });

                        let visiblePlayers = players.filter(function(item) {
                            return item.attr('visible');
                        });

                        if (visiblePlayers.attr('length') == 0) {
                            group.attr('visible', false);
                        } else {
                            totalVisiblePlayers += visiblePlayers.attr(
                                'length',
                            );
                            group.attr('visible', true);
                        }
                    });

                    let visibleGroups = groups.filter(function(item) {
                        return item.attr('visible');
                    });

                    if (totalVisiblePlayers > playerBasicViewLimit) {
                        this.attr('basicSearch', false);
                    } else {
                        this.attr('basicSearch', true);
                    }

                    if (visibleGroups.attr('length') == 0) {
                        this.attr('groupedEmptyResult', true);
                    } else {
                        this.attr('groupedEmptyResult', false);
                    }

                    can.batch.stop();
                    return groups;
                },
            },
            filteredPlayers: {
                get() {
                    can.batch.start();
                    let players = this.attr('players');
                    let filter = this.attr('activeFilter').attr('type');
                    let searchString = this.attr('searchString');
                    let playerBasicViewLimit = this.attr(
                        'playerBasicViewLimit',
                    );
                    let basicSearch = this.attr('basicSearch');

                    players.each((player) => {
                        if (filter == 'local') {
                            if (player.attr('hasLocalQualifier')) {
                                player.attr('visible', true);
                            } else {
                                player.attr('visible', false);
                            }
                        } else if (filter == 'final') {
                            if (player.attr('hasFinalQualifier')) {
                                player.attr('visible', true);
                            } else {
                                player.attr('visible', false);
                            }
                        } else if (filter == 'exemptions') {
                            if (player.attr('hasExemptions')) {
                                player.attr('visible', true);
                            } else {
                                player.attr('visible', false);
                            }
                        } else {
                            player.attr('visible', true);
                        }

                        if (searchString && player.attr('visible')) {
                            searchString = searchString.toLocaleLowerCase();
                            if (
                                !_.startsWith(
                                    player
                                        .attr('firstName')
                                        .toLocaleLowerCase(),
                                    searchString,
                                ) &&
                                !_.startsWith(
                                    player.attr('lastName').toLocaleLowerCase(),
                                    searchString,
                                )
                            ) {
                                player.attr('visible', false);
                            }
                        }
                    });

                    let visiblePlayers = players.filter(function(item) {
                        return item.attr('visible');
                    });

                    if (visiblePlayers.attr('length') > playerBasicViewLimit) {
                        this.attr('basicSearch', false);
                    } else {
                        this.attr('basicSearch', true);
                    }

                    if (visiblePlayers.attr('length') == 0) {
                        this.attr('emptyResult', true);
                    } else {
                        this.attr('emptyResult', false);
                    }

                    players.attr('comparator', 'lastName');
                    players.sort();

                    can.batch.stop();
                    return players;
                },
            },
        },
        setSearchValue: function(event) {
            let searchValue = can.trim($(event.target).val());
            this.attr('searchString', searchValue);
        },
        onFilterChange: function(event) {
            let drawer = $('.c-qualification-drawer');
            if (drawer && drawer.length) {
                drawer.remove();
                $('.s-content__player.is-checked').removeClass('is-checked');
            }
            this.attr('activeFilter').attr('type', event.payload.value);
        },
    },
    events: {
        inserted() {
            new FeedService({
                feedUrl: erinHillsFeedUrl,
                fromCache: false,
                autoUpdate: false,
            })
                .on('data', (type, data) => {
                    if (data) {
                        DomEventsManager.subscribe(this);

                        this.viewModel.attr('players', _.castArray(data));
                        this.viewModel.attr('activeFilter', { type: 'all' });
                        this.viewModel.attr('filters', new can.Map(filters));

                        this.updatePlayers();
                        this.createAndFillGroups();
                        this.setViewType();
                        this.viewModel.attr('isLoaded', true);
                    }
                })
                .on('error', (error) => {
                    console.error('Error fetching erin hills data', error);
                })
                .fetch();
        },
        setViewType: function() {
            let players = this.viewModel
                .attr('players')
                .filter(function(player) {
                    return player.attr('visible');
                });

            if (players.length > this.viewModel.attr('playerBasicViewLimit')) {
                this.viewModel.attr('basicSearch', false);
            } else {
                this.viewModel.attr('basicSearch', true);
            }
        },
        updatePlayers: function() {
            this.viewModel.attr('players').each((player, index) => {
                player.attr('visible', true);
                player.attr(
                    'hasLocalQualifier',
                    player.attr('localQualifier') ? true : false,
                );
                player.attr(
                    'hasFinalQualifier',
                    player.attr('sectionalQualifier') ? true : false,
                );
                player.attr(
                    'hasExemptions',
                    player.attr('exemptions') &&
                        player.attr('exemptions').length
                        ? true
                        : false,
                );
                player.attr(
                    'qualifyingStatus',
                    this.viewModel.attr('qualifyingStatus'),
                );
                player.attr(
                    'competitionTitle',
                    this.viewModel.attr('competitionTitle'),
                );
                player.attr('logoImage', this.viewModel.attr('logoImage'));
                player.attr('location', this.viewModel.attr('location'));
            });
        },
        createAndFillGroups: function() {
            let groups = [],
                sortedGroups = [];

            this.viewModel.attr('players').each((player, index) => {
                let firstLetterLastName = player.attr('lastName').substr(0, 1);

                let groupIndex = _.findIndex(groups, function(item) {
                    return item.letter == firstLetterLastName;
                });

                if (groupIndex == -1) {
                    groups.push({
                        letter: firstLetterLastName,
                        players: [player],
                        visible: true,
                    });
                } else {
                    groups.forEach(function(group) {
                        if (group.letter == firstLetterLastName) {
                            group.players.push(player);
                        }
                    });
                }
            });

            groups.forEach(function(group, index) {
                groups[index].players = _.sortBy(
                    groups[index].players,
                    function(player) {
                        return player.lastName;
                    },
                );
            });

            sortedGroups = _.sortBy(groups, function(group) {
                return group.letter;
            });

            this.viewModel.attr('groups', sortedGroups);
        },

        getPlayerFromPlayerCard(element) {
            const playerIdentifier = element
                .closest('.player-detail-link')
                .attr('data-user-identifier');
            if (playerIdentifier) {
                return this.viewModel.attr('players').filter((player) => {
                    return player.attr('identifier') == playerIdentifier;
                })[0];
            }
            return null;
        },

        showQualificationDrawer: function(element) {
            let playerDetailLink = element.closest('.player-detail-link');
            let playerIdentifier = playerDetailLink.attr(
                'data-user-identifier',
            );
            this.viewModel.attr('activePlayerId', playerIdentifier);
            let isBasic = this.element.find('.basic-section').is(':visible');
            let drawers = this.element.find('.c-qualification-drawer');
            let screenSize = appContext.model.screen.attr('screenSize');
            let playerData;
            let elementTarget = $(playerDetailLink);

            let playersPerRow = 4;
            if (screenSize == 'medium') {
                playersPerRow = 3;
            }

            if (isBasic) {
                if (screenSize !== 'small' && screenSize !== 'extra-small') {
                    let visiblePlayers = this.element.find(
                        '.player-detail-link',
                    ).length;
                    let clickedPlayerIndex = this.element
                        .find('.player-detail-link')
                        .index(playerDetailLink);
                    let clickedPlayerRow = Math.ceil(
                        (clickedPlayerIndex + 1) / playersPerRow,
                    );

                    let targetPlayerIndex =
                        Math.ceil(clickedPlayerRow * playersPerRow) - 1;
                    if (targetPlayerIndex >= visiblePlayers) {
                        targetPlayerIndex = visiblePlayers - 1;
                    }

                    elementTarget = $('.player-detail-link').eq(
                        targetPlayerIndex,
                    );
                }

                playerData = this.viewModel.attr('players').filter((player) => {
                    return player.attr('identifier') == playerIdentifier;
                })[0];
            } else {
                if (screenSize !== 'small' && screenSize !== 'extra-small') {
                    let sectionPlayers = $(element)
                        .closest('.s-content-section')
                        .find('.player-detail-link');
                    let visiblePlayers = sectionPlayers.length;
                    let clickedPlayerIndex = sectionPlayers.index(
                        playerDetailLink,
                    );
                    let clickedPlayerRow = Math.ceil(
                        (clickedPlayerIndex + 1) / playersPerRow,
                    );

                    let targetPlayerIndex =
                        Math.ceil(clickedPlayerRow * playersPerRow) - 1;
                    if (targetPlayerIndex >= visiblePlayers) {
                        targetPlayerIndex = visiblePlayers - 1;
                    }

                    elementTarget = sectionPlayers.eq(targetPlayerIndex);
                }

                this.viewModel.attr('groups').each(function(group) {
                    if (playerData && playerData.attr('identifier')) {
                        return;
                    }
                    playerData = group.attr('players').filter((player) => {
                        return player.attr('identifier') == playerIdentifier;
                    })[0];
                });
            }

            if (drawers) {
                drawers.remove();
            }

            if (!playerData) {
                return;
            }

            let drawerData = {
                localQualifier: playerData.localQualifier,
                sectionalQualifier: playerData.sectionalQualifier || null,
                exemptionQualifier: playerData.exemptionQualifier || null,
                exemptions: playerData.exemptions || [],
                isLinkPlayer: playerData.isLinkPlayer,
                identifier: playerData.identifier,
                qualifyingStatus: playerData.qualifyingStatus,
                competitionTitle: playerData.competitionTitle,
                logoImage: playerData.logoImage,
                location: playerData.location,
            };

            elementTarget.after(
                can.stache(`<qualification-drawer 
                            {localQualifier}="localQualifier" 
                            {sectionalQualifier}="sectionalQualifier" 
                            {exemptionQualifier}="exemptionQualifier" 
                            {exemptions}="exemptions" 
                            {identifier}="identifier"
                            {isLinkPlayer}="isLinkPlayer"
                            {qualifyingStatus}="qualifyingStatus"
                            {competition-title}="competitionTitle"
                            {logo-image}="logoImage"
                            {location}="location"
                        ></qualification-drawer>`)(drawerData),
            );
        },
        onWindowResize: function() {
            this.element.find('.c-qualification-drawer').remove();
            let checkedPlayer = this.element.find(
                '.s-content__player.is-checked',
            );
            if (checkedPlayer) {
                this.showQualificationDrawer(checkedPlayer);
            }
        },
        '.s-content__player click': function(element, event) {
            this.element
                .find('.player-qualification-drawer.active')
                .removeClass('active');
            const player = this.getPlayerFromPlayerCard(element);
            if (
                player.attr('identifier') !=
                this.viewModel.attr('activePlayerId')
            ) {
                dtm.trackRoadToUsoDigitalData(
                    [player.attr('firstName'), player.attr('lastName')].join(
                        ' ',
                    ),
                );
            }
            this.viewModel.attr('activePlayerId', null);

            if (element.hasClass('is-checked')) {
                element.removeClass('is-checked');
                this.element.find('qualification-drawer').remove();
                element.find('.js-info-btn').attr('aria-expanded', false);
            } else {
                this.element
                    .find('.s-content__player.is-checked')
                    .removeClass('is-checked');
                this.element.find('qualification-drawer').remove();
                this.element.find('.js-info-btn').attr('aria-expanded', false);
                element.addClass('is-checked');
                element.find('.js-info-btn').attr('aria-expanded', true);
                this.showQualificationDrawer(element);
            }
        },
        '.s-head-search .s-head-search__icon-search click': function(
            element,
            event,
        ) {
            var searchHead = element.closest('.s-head-search');
            searchHead.find('.s-head-search__input').val('');
            if (searchHead.hasClass('is-expanded')) {
                this.viewModel.attr('searchString', null);
            }
            searchHead.toggleClass('is-expanded');
        },
    },
});
